export default {
  getTerm: state => state.term,
  getIsEditing: state => state.isEditing
}
